import './css/FlaFramework.css';
import './css/App.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";



//pages:
import Home from './views/home';
import Principal from './views/principal';

export default function App() {

  return (
    <Router>
      <Routes>
        <Route path="" element={<Principal />} />
        <Route path="/site" element={<Home />} />
      </Routes>
    </Router>
  );
}

